export const CSRF_STATE_KEY = 'CSRFState';
function makeKey(subKey) {
    if (!subKey) {
        return CSRF_STATE_KEY;
    }
    return `${CSRF_STATE_KEY}.${subKey}`;
}
export function setCSRFState(CSRFState, subKey) {
    localStorage.setItem(makeKey(subKey), CSRFState);
}
export function getCSRFState(subKey) {
    var _a;
    return (_a = localStorage.getItem(makeKey(subKey))) !== null && _a !== void 0 ? _a : '';
}
export function clearCSRFState(subKey) {
    localStorage.removeItem(makeKey(subKey));
}
//# sourceMappingURL=authStateHelpers.js.map